import { useTranslation } from 'react-i18next';
import FormBuilder from '../../common/form-builder/FormBuilder';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

export default function MyWatchListListFormGeneralFields() {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();

  const handleActiveInactiveChange = async (e: any) => {
    if (e.event) {
      setValue('active', e.value);
    }
  };

  const generalFormConfig = [
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'fleetname',
      label: t('labels.fleetName'),
      control: control,
      fieldType: 'text',
      isRequired: true,
      maxLength: 100,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'color',
      label: t('labels.color'),
      control: control,
      fieldType: 'color',
      isRequired: true,
    },
    {
      name: 'active',
      label: t('labels.active'),
      control: control,
      fieldType: 'switch',
      //permission: 'RoleManagement.Activate/Inactive',
      onChange: handleActiveInactiveChange,
    },
  ];

  return (
    <>
      <div className="row">
        <FormBuilder formConfig={generalFormConfig} />
      </div>
    </>
  );
}
